<div #container class="messages-container" (scroll)="onScroll()">
   <ng-content></ng-content>
</div>